var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKomi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0361 7.74394L12.0794 7.70032C13.929 5.83683 13.9074 2.82956 12.0361 1C10.1984 2.85137 10.1768 5.83683 11.9928 7.70032L12.0361 7.74394Z",
    fill: "url(#komi0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9567 13.1599C22.107 11.2964 19.1221 11.3183 17.3061 13.2036C19.1437 15.0549 22.107 15.0767 23.9567 13.2472L24 13.2036L23.9567 13.1599Z",
    fill: "url(#komi1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69393 13.0509L6.65063 13.0073C4.80096 11.1438 1.816 11.1656 0 13.0509C1.83764 14.9023 4.80096 14.9241 6.65063 13.0945L6.69393 13.0509Z",
    fill: "url(#komi2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5893 4.54281C17.9964 4.57431 15.9158 6.70436 15.9158 9.31664V9.36995H15.9687C18.5809 9.33845 20.6518 7.16478 20.5893 4.54281Z",
    fill: "url(#komi3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8076 16.7027H15.7643V16.7657C15.7859 19.3998 17.9218 21.496 20.5244 21.4426C20.5051 18.8304 18.4101 16.7124 15.8076 16.7027Z",
    fill: "url(#komi4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57907 21.3578C6.17198 21.3796 8.29585 19.2932 8.33915 16.6809L8.34877 16.6155H8.29826C5.6837 16.5937 3.56945 18.7237 3.57907 21.3578Z",
    fill: "url(#komi5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05292 9.42326H8.10583V9.36995C8.1371 6.74798 6.0445 4.59612 3.43235 4.59612C3.39868 7.2084 5.46001 9.36995 8.05292 9.42326Z",
    fill: "url(#komi6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4702 13.126C14.4702 11.7714 13.3806 10.6761 12.0385 10.6761C10.6939 10.6761 9.60673 11.7738 9.60673 13.126C9.60673 14.1099 10.1816 14.9531 11.0114 15.3457L9.75586 22H14.4414L13.0968 15.3336C13.9074 14.9362 14.4702 14.0977 14.4702 13.126Z",
    fill: "url(#komi7_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "komi0_linear",
    x1: 18.8461,
    y1: 11.2504,
    x2: 5.50886,
    y2: 11.2504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "komi1_linear",
    x1: 18.8461,
    y1: 11.2504,
    x2: 5.50886,
    y2: 11.2504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "komi2_linear",
    x1: 18.8461,
    y1: 11.2504,
    x2: 5.50886,
    y2: 11.2504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "komi3_linear",
    x1: 18.8461,
    y1: 11.2504,
    x2: 5.50886,
    y2: 11.2504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "komi4_linear",
    x1: 18.8461,
    y1: 11.2504,
    x2: 5.50886,
    y2: 11.2504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "komi5_linear",
    x1: 18.8461,
    y1: 11.2504,
    x2: 5.50886,
    y2: 11.2504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "komi6_linear",
    x1: 18.8461,
    y1: 11.2504,
    x2: 5.50886,
    y2: 11.2504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "komi7_linear",
    x1: 18.8461,
    y1: 11.2504,
    x2: 5.50886,
    y2: 11.2504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17E391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#58E5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60E5E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKomi);
export default __webpack_public_path__ + "static/media/komi.f78b13bd.svg";
export { ForwardRef as ReactComponent };